import { render, staticRenderFns } from "./JobsRegistryNewForm.vue?vue&type=template&id=6930d878"
import script from "./JobsRegistryNewForm.vue?vue&type=script&lang=js"
export * from "./JobsRegistryNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports